import styled from 'styled-components';
import { Switch as MuiSwitch } from '@mui/material';

type SwitchType = {
  switchSize?: 'md' | 'sm';
};
export const Switch = styled(MuiSwitch)<SwitchType>(({ theme, switchSize }) => ({
  width: switchSize === 'md' ? 44 : 36,
  height: switchSize === 'md' ? 24 : 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: `translateX(${switchSize === 'md' ? '20px' : '16px'})`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.base.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: theme.palette.grey[100],
      },
      '& .MuiSwitch-thumb': {
        color: 'white',
      },
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[50],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  '& .MuiSwitch-thumb': {
    color: 'white',
    boxSizing: 'border-box',
    width: switchSize === 'md' ? 20 : 16,
    height: switchSize === 'md' ? 20 : 16,
    boxShadow: theme.shadows[26],
  },
  '& .MuiSwitch-track': {
    borderRadius: '12px',
    backgroundColor: theme.palette.grey[100],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'box-shadow'], {
      duration: 500,
    }),
  },
  '&:focus-within': {
    '.MuiSwitch-track': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  '&:hover': {
    '.MuiSwitch-track': {
      boxShadow: `0px 0px 0px 4px ${theme.palette.primary[100]}`,
      borderRadius: '12px',
    },
  },
  overflow: 'visible',
}));

